import React from "react";
import FormHelperText from '@mui/material/FormHelperText';
import clsx from "clsx";
import Box from "@mui/material/Box";

export const WrapControler = (props) => {
  let { sx, className, children, topwrap, name, meta: { touched, error } = {} } = props;
  let helperText = touched && error ? error : null;
  return (<>
    <Box sx={sx} className={clsx(className, { 'Mui-error': !!helperText })}>
      {( topwrap && helperText) && <FormHelperText>{helperText}</FormHelperText>}
      {typeof children === 'function' && children({ ...props, touched })}
      {typeof children !== 'function' && children}
      {( !topwrap && helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </Box>
  </>)
};

export const FieldWrap = ({ sx, children, size, className, style }) => (<>
  <Box className={className} sx={sx} style={{ ...style, minHeight: `${size || 70}px`}}>
    {children}
  </Box>
</>)

export default FieldWrap;
